export default {
  FETCH_ANNOUNCEMENTS_REQUEST: 'FETCH_ANNOUNCEMENTS_REQUEST',
  FETCH_ANNOUNCEMENTS_SUCCESS: 'FETCH_ANNOUNCEMENTS_SUCCESS',
  FETCH_ANNOUNCEMENTS_FAILURE: 'FETCH_ANNOUNCEMENTS_FAILURE',

  TOGGLE_PIN_ANNOUNCEMENTS: 'TOGGLE_PIN_ANNOUNCEMENTS',

  DELETE_ACTIVE_ANNOUNCEMENT: 'DELETE_ACTIVE_ANNOUNCEMENT',
  DELETE_ARCHIVED_ANNOUNCEMENT: 'DELETE_ARCHIVED_ANNOUNCEMENT',
  DELETE_SCHEDULED_ANNOUNCEMENT: 'DELETE_SCHEDULED_ANNOUNCEMENT',

  ADD_ACTIVE_ANNOUNCEMENT: 'ADD_ACTIVE_ANNOUNCEMENT',
  ADD_ARCHIVED_ANNOUNCEMENT: 'ADD_ARCHIVED_ANNOUNCEMENT',
  ADD_SCHEDULED_ANNOUNCEMENT: 'ADD_SCHEDULED_ANNOUNCEMENT',

  UPDATE_ANNOUNCEMENTS_REQUEST: 'UPDATE_ANNOUNCEMENTS_REQUEST',
  UPDATE_ANNOUNCEMENTS_SUCCESS: 'UPDATE_ANNOUNCEMENTS_SUCCESS',
  UPDATE_ANNOUNCEMENTS_FAILURE: 'UPDATE_ANNOUNCEMENTS_FAILURE',
};



// WEBPACK FOOTER //
// ./src/modules/dashboard/actions/announcements/action-types.js